import { useCallback, useEffect, useState } from "react";
import { rideryCodesService } from "../services/rideryCodesServide";
import { notify } from "../assets/helpers/toast";

export default function useRideryCodes() {
  const [isLoading, setIsLoading] = useState(false);
  const [fileUploaded, setFileUploaded] = useState("");
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [rideryCodeData, setRideryCodeData] = useState({
    limit: 50,
    offset: 0, //Elementos que ya pasaron la pagina
    data: [],
    count: 0, //Cantidad de elementos
    page: 1,
    description: "",
    type: "Inventario",
  });
  const [openBlockModal, setOpenBlockModal] = useState({
    isOpen: false,
    data: {
      id: "",
      name: "",
      status: "",
    },
  });

  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      if (
        ![
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-excel",
        ].includes(file.type)
      ) {
        notify("Por favor, sube un archivo de Excel (.xlsx o .xls)", "error");
        return null;
      }
      let maxWeight = 5; // Puedes cambiar este valor
      if (file.size * 0.000001 > maxWeight) {
        notify(
          `El archivo de Excel no debe superar los ${maxWeight} MB`,
          "error"
        );
      } else {
        setFileUploaded(file);
      }
    });
  }, []);

  const handlePageChange = (event, value) => {
    setRideryCodeData((prevState) => {
      return {
        ...prevState,
        page: value,
        offset: (value - 1) * rideryCodeData?.limit,
      };
    });
  };

  const handlePageChangeApplicative = (event, value) => {
    setRideryCodeData((prevState) => ({
      ...prevState,
      page: value,
      offset: (value - 1) * rideryCodeData?.limit,
    }));
  };

  const appendFile = (file) => {
    const formData = new FormData();
    formData.append("codesFile", file);
    formData.append("fileName", file.name);
    return formData;
  };

  const resetPagination = () => {
    if (rideryCodeData?.limit === 50 && rideryCodeData?.offset === 0) {
      getRideryCodes({
        limit: rideryCodeData?.limit,
        offset: rideryCodeData?.offset,
      });
    } else {
      setRideryCodeData((prevState) => ({
        ...prevState,
        page: 1,
        offset: 0,
        limit: 50,
      }));
    }
  };

  const getRideryCodes = useCallback(
    ({
      limit = rideryCodeData?.limit ? rideryCodeData?.limit : 50,
      offset = rideryCodeData?.offset ? rideryCodeData?.offset : 0,
    }) => {
      setIsLoading(true);

      rideryCodesService
        .getListRideryCodes({
          limit,
          offset,
        })
        .then((response) => {
          if (response.status === 200) {
            setRideryCodeData((prevState) => {
              return {
                ...prevState,
                data: response?.data?.externalDiscountCodes,
                count: response?.data?.total,
              };
            });

            setTimeout(() => {
              setIsLoading(false);
            }, 500);
          } else {
            notify(`${response.message}` || "error", "error");
            setTimeout(() => {
              setIsLoading(false);
            }, 500);
          }
        })
        .catch((error) => {
          notify(`${error.message}` || "error", "error");
          setTimeout(() => {
            setIsLoading(false);
          }, 500);
        });

      return true;
    },
    [rideryCodeData?.limit, rideryCodeData?.offset]
  );

  const handleCloseModal = () => {
    setShowUploadModal(false);
    setFileUploaded("");
  };

  const createRideryCodes = async () => {
    setIsLoading(true);
    const fileToPost = appendFile(fileUploaded);
    rideryCodesService.setInventory(fileToPost).then(async (response) => {
      setIsLoading(false);
      if ([200, 201].includes(response.status)) {
        if (response?.data?.fileErrors) {
          notify(
            `El archivo contiene errores, se han actualizado solo los datos correctos`,
            "error"
          );

          const link = document.createElement("a");
          link.href = response?.data?.fileErrors?.file;
          link.setAttribute("download", "errores.xlsx"); // any other extension
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          handleCloseModal();
          resetPagination();
        } else {
          notify(`Archivo cargado con exito`, "success");
          handleCloseModal();
          resetPagination();
        }
      } else {
        notify(`${response.message}`, "error");
      }
    }).catch((error) => {
      setIsLoading(false);
      console.error(error);
      notify(`${error.message}` || "error", "error");
    });
  };

  const cancelBlockModal = () => {
    setOpenBlockModal({
      isOpen: false,
      data: {
        id: "",
        name: "",
        status: "",
      },
    });
  }
  

  const handleBlockCode = () => {
      const { id, status } = openBlockModal.data;
  
      const statusToSend = status === "Activo" ? "Bloqueado" : "Activo";
      rideryCodesService
        .updateStatus(id, { status: statusToSend })
        .then((response) => {
          if (response.status === 200) {
            cancelBlockModal();
            console.log('externalDiscountCode', response.data);
            const statusCode = response.data.discountCode.status === "Activo"
            notify(`Código Ridery ${statusCode ? "Activado" : "Bloqueado"} con éxito`, "success");
            resetPagination();
          } else {
            notify(`${response.message}` || "error", "error");
            cancelBlockModal();
          }
        })
        .catch((error) => {
          notify(`${error.message}` || "error", "error");
          cancelBlockModal();
        });
      return true;
    };

  useEffect(() => {
    getRideryCodes({
      limit: rideryCodeData?.limit,
      offset: rideryCodeData?.offset,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rideryCodeData?.page, rideryCodeData?.limit, rideryCodeData?.offset, getRideryCodes]);

  return {
    isLoading,
    showUploadModal,
    onDrop,
    createRideryCodes,
    handlePageChange,
    handlePageChangeApplicative,
    setShowUploadModal,
    setFileUploaded,
    fileUploaded,
    handleCloseModal,
    rideryCodeData,
    handleBlockCode,
    cancelBlockModal,
    setOpenBlockModal,
    openBlockModal,
  };
}
